import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getPromos } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { getProfileOwnerUser } from '../../../../../selectors/users';
import { AppState } from '../../../../../../types/store';
import { Props } from './CoreSaleTooltip';

export type StateProps = Pick<Props, 'currentPromo' | 'profileOwner'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const currentPromo = getPromos(state)?.[0];
  const profileOwner = getProfileOwnerUser(state);
  return {
    currentPromo,
    profileOwner,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
